<div class="slideout-content">
  <!-- Modal to add new user starts-->
  <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
    <div class="modal-dialog">
      <form class="add-new-user modal-content pt-0" (ngSubmit)="(editUserForm.form.valid)" #editUserForm="ngForm">
        <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="toggleSidebar('edit-user-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" id="exampleModalLabel">Edit User</h5>
        </div>

        <div class="modal-body flex-grow-1">
          <div class="row">
            <div class="form-group col-6">
              <label class="form-label" for="edit-user-sidebar-firstname">First Name</label>
              <input
                type="text"
                class="form-control dt-first-name"
                id="edit-user-sidebar-firstname"
                placeholder="John"
                name="user-firstname"
                [(ngModel)]="currentUser.firstName"
                [class.error]="editUserForm.submitted && FNameRef.invalid"
                #FNameRef="ngModel"
                required
                aria-label="John"
                aria-describedby="edit-user-sidebar-firstname2"
              />
              <span *ngIf="editUserForm.submitted && FNameRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FNameRef.errors.required">This field is required!</small>
              </span>
            </div>
            <div class="form-group col-6">
              <label class="form-label" for="edit-user-sidebar-lastname">Last Name</label>
              <input
                type="text"
                id="edit-user-sidebar-lastname"
                class="form-control dt-lastname"
                placeholder="Doe"
                aria-label="Doe"
                aria-describedby="edit-user-sidebar-lastname2"
                name="user-lastname"
                [(ngModel)]="currentUser.lastName"
                [class.error]="editUserForm.submitted && FUserNameRef.invalid"
                #FUserNameRef="ngModel"
                required
              />
              <span *ngIf="editUserForm.submitted && FUserNameRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FUserNameRef.errors.required">This field is required!</small>
              </span>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="edit-user-sidebar-email">Email</label>
            <input
              type="text"
              id="edit-user-sidebar-email"
              class="form-control dt-email"
              placeholder="john.doe@example.com"
              aria-label="john.doe@example.com"
              aria-describedby="edit-user-sidebar-email2"
              name="user-email"
              [(ngModel)]="currentUser.email"
              [class.error]="editUserForm.submitted && FEmailRef.invalid"
              #FEmailRef="ngModel"
              required
            />
            <span *ngIf="editUserForm.submitted && FEmailRef.invalid" class="invalid-form">
              <small class="form-text text-danger" *ngIf="FEmailRef.errors.required">This field is required!</small>
            </span>
          </div>
          <div class="form-group">
            <label class="form-label" for="edit-user-sidebar-user-role">User Role</label>
            <select id="edit-user-sidebar-user-role" class="form-control" [disabled]="this.myUser.id == currentUser.id" [(ngModel)]="currentUser.role" name="edit-user-sidebar-user-role">
              <option *ngFor="let role of data.accountSetting.config.userRoles; let i = index"
              [value]="role">{{ role }}</option>
            </select>
          </div>
            
          <div class="form-group">
            <label>Locations</label>
            <!-- Select Multi with Icon -->
            <ng-select
              [items]="locations"
              [multiple]="true"
              bindLabel="name"
              bindValue="id"
              [closeOnSelect]="false"
              name="user-locations"
              [(ngModel)]="currentUser.userLocations"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label">
                  <img *ngIf="item.locationLogo == ''" src="../../../../../assets/images/profile/user-uploads/location-00.png" width="20px" height="20px" /> 
                  <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" width="20px" height="20px" />
                  {{ item.locationName }}</span
                >
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>

              <ng-template ng-header-tmp>
                <a
                  (click)="selectAll()"
                  class="btn btn-flat-primary btn-sm"
                >
                  Select all
                </a>
                <a
                  (click)="unselectAll()"
                  class="btn btn-flat-primary btn-sm"
                >
                  Unselect all
               </a>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <img *ngIf="item.locationLogo == ''" src="../../../../../assets/images/profile/user-uploads/location-00.png" width="20px" height="20px" /> 
                <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" width="20px" height="20px" />

                {{ item.locationName }}
              </ng-template>
            </ng-select>
            <!--/ Select Multi with Icon -->
          </div>

          <!-- <div class="form-group">
            <label for="account-new-password">New Password</label>
            <div class="input-group form-password-toggle input-group-merge">
              <input
                [type]="passwordTextTypeNew ? 'text' : 'password'"
                id="account-new-password"
                name="new-password"
                class="form-control"
                placeholder="············"
                aria-describedby="new-password"
                autocomplete="new-password"
                tabindex="6"        
              />                              
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextTypeNew,
                      'icon-eye': !passwordTextTypeNew
                    }"
                    (click)="togglePasswordTextTypeNew()"
                  ></i
                ></span>
              </div>
              
            </div>          
          </div>
          <div class="form-group">
            <label for="account-retype-new-password">Retype New Password</label>
            <div class="input-group form-password-toggle input-group-merge">
              <input
                [type]="passwordTextTypeRetype ? 'text' : 'password'"
                class="form-control"
                id="account-retype-new-password"
                name="confirm-new-password"
                placeholder="············"
                aria-describedby="confirm-password"
                autocomplete="new-password"
                tabindex="7"        
                [class.error]="!alertClose"         
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextTypeRetype,
                      'icon-eye': !passwordTextTypeRetype
                    }"
                    (click)="togglePasswordTextTypeRetype()"
                  ></i
                ></span>
              </div>
            </div>
            <span *ngIf="!alertClose" class="invalid-form">
              <small class="form-text text-danger">Retyped new password is not the same.</small>
            </span>              
          </div> -->

          <div class="col-12" *ngIf="!loadingButton">
            <button type="submit" class="btn btn-primary mr-1" (click)="submit(editUserForm)" rippleEffect>
              Save changes
            </button>
            <button type="reset" class="btn btn-outline-secondary" (click)="toggleSidebar('edit-user-sidebar')" >Cancel</button>
          </div>
          <div class="col-12" *ngIf="loadingButton">
            <button class="btn btn-outline-primary" type="button" disabled rippleEffect>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ml-25 align-middle">Saving...</span>
            </button>
          </div>
          <div *ngIf="!alertClose" style="padding: 12px;">
          
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Modal to add new user Ends-->
</div>
